import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function ContactPage() {
  return <Layout data-id="element-353">
      <section className="min-h-screen bg-alabaster flex flex-col lg:flex-row" data-id="element-354">
        {/* Left Side: Info */}
        <div className="flex-1 p-8 md:p-24 flex flex-col justify-center border-b-3 lg:border-b-0 lg:border-r-3 border-charcoal" data-id="element-355">
          <div className="max-w-md mx-auto lg:mx-0" data-id="element-356">
            <span className="inline-block bg-espresso/10 text-espresso px-4 py-2 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-357">
              Get In Touch
            </span>
            <h1 className="text-5xl md:text-6xl font-bold mb-8" data-id="element-358">
              Let's Start Your Project.
            </h1>
            <p className="text-charcoal/60 mb-12 leading-relaxed" data-id="element-359">
              Ready to transform your kitchen? Contact our Bowie design center
              to schedule a consultation or request a detailed quote.
            </p>

            <div className="space-y-8" data-id="element-360">
              <div className="flex gap-6" data-id="element-361">
                <div className="w-12 h-12 border-2 border-espresso flex items-center justify-center shrink-0" data-id="element-362">
                  <PhoneIcon className="w-5 h-5 text-espresso" data-id="element-363" />
                </div>
                <div data-id="element-364">
                  <h4 className="font-bold uppercase tracking-widest text-xs mb-1" data-id="element-365">
                    Call Us
                  </h4>
                  <p className="text-lg font-bold" data-id="element-366">
                    <a href="tel:4107776984" className="hover:text-espresso transition-colors" data-id="element-367">
                      (410) 777-6984
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex gap-6" data-id="element-368">
                <div className="w-12 h-12 border-2 border-espresso flex items-center justify-center shrink-0" data-id="element-369">
                  <MailIcon className="w-5 h-5 text-espresso" data-id="element-370" />
                </div>
                <div data-id="element-371">
                  <h4 className="font-bold uppercase tracking-widest text-xs mb-1" data-id="element-372">
                    Email Us
                  </h4>
                  <p className="text-lg font-bold" data-id="element-373">
                    <a href="mailto:nkrefacers@gmail.com" className="hover:text-espresso transition-colors" data-id="element-374">
                      nkrefacers@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex gap-6" data-id="element-375">
                <div className="w-12 h-12 border-2 border-espresso flex items-center justify-center shrink-0" data-id="element-376">
                  <MapPinIcon className="w-5 h-5 text-espresso" data-id="element-377" />
                </div>
                <div data-id="element-378">
                  <h4 className="font-bold uppercase tracking-widest text-xs mb-1" data-id="element-379">
                    Visit Us
                  </h4>
                  <p className="text-lg font-bold" data-id="element-380">
                    12810 7th st Bowie MD 20720
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="flex-1 bg-white p-8 md:p-24 flex items-center justify-center" data-id="element-381">
          <div className="w-full max-w-md" data-id="element-382">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-383">
              <div className="grid grid-cols-2 gap-6" data-id="element-384">
                <div className="space-y-2" data-id="element-385">
                  <label className="text-xs font-bold uppercase tracking-widest" data-id="element-386">
                    First Name
                  </label>
                  <input type="text" className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 transition-colors" placeholder="Jane" data-id="element-387" />
                </div>
                <div className="space-y-2" data-id="element-388">
                  <label className="text-xs font-bold uppercase tracking-widest" data-id="element-389">
                    Last Name
                  </label>
                  <input type="text" className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 transition-colors" placeholder="Doe" data-id="element-390" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-391">
                <label className="text-xs font-bold uppercase tracking-widest" data-id="element-392">
                  Email Address
                </label>
                <input type="email" className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 transition-colors" placeholder="jane@example.com" data-id="element-393" />
              </div>

              <div className="space-y-2" data-id="element-394">
                <label className="text-xs font-bold uppercase tracking-widest" data-id="element-395">
                  Project Type
                </label>
                <select className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 bg-transparent transition-colors" data-id="element-396">
                  <option data-id="element-397">Full Cabinet Refacing</option>
                  <option data-id="element-398">Door Replacement Only</option>
                  <option data-id="element-399">Hardware Upgrade</option>
                  <option data-id="element-400">General Inquiry</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-401">
                <label className="text-xs font-bold uppercase tracking-widest" data-id="element-402">
                  Message
                </label>
                <textarea className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 min-h-[120px] transition-colors" placeholder="Tell us about your kitchen..." data-id="element-403"></textarea>
              </div>

              <button className="w-full bg-charcoal text-alabaster py-5 font-bold uppercase tracking-[0.2em] text-sm hover:bg-espresso transition-colors mt-8" data-id="element-404">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </Layout>;
}